export enum ViewerFont {
  RidiBatang = 'RIDIBatang',
  Pretendard = 'Pretendard',
}

export enum ViewMode {
  Normal = 'normal',
  Binging = 'binging',
}

export const ViewerFonts = [ViewerFont.RidiBatang, ViewerFont.Pretendard];

export const ViewerFontFileName = {
  [ViewerFont.RidiBatang]: 'RIDIBatang',
  [ViewerFont.Pretendard]: 'Pretendard',
};

export const ViewerFontOTFFileNames = ViewerFonts.map(font => `${ViewerFontFileName[font]}.otf`);

export enum ViewerTheme {
  White = 'white',
  Sepia = 'sepia',
  DarkGray = 'darkGray',
  Black = 'black',
  DirittoGreen = 'DirittoGreen',
}

// 뷰어 설정 글자 크기
export enum ViewerFontSize {
  Level1 = '12',
  Level2 = '13',
  Level3 = '14',
  Level4 = '15',
  Level5 = '16',
  Level6 = '18', // default
  Level7 = '20',
  Level8 = '22',
  Level9 = '24',
  Level10 = '26',
  Level11 = '30',
  Level12 = '34',
}

// 뷰어 설정 줄 간격
export enum ViewerLineHeight {
  Level1 = '100', // default
  Level2 = '120',
  Level3 = '140',
  Level4 = '160',
  Level5 = '180',
  Level6 = '200',
  Level7 = '220',
  Level8 = '240',
  Level9 = '260',
  Level10 = '280',
  Level11 = '300',
  Level12 = '320',
}

// 뷰어 설정 좌우여백
export enum ViewerPadding {
  Level1 = '8',
  Level2 = '12',
  Level3 = '16', // default
  Level4 = '20',
  Level5 = '24',
  Level6 = '28',
  Level7 = '32',
  Level8 = '36',
  Level9 = '40',
  Level10 = '44',
  Level11 = '48',
  Level12 = '52',
}

// 뷰어 설정 문단 간격
export enum ViewerParagraphIndent {
  Level1 = '0',
  Level2 = '20',
  Level3 = '40',
  Level4 = '60', // default
  Level5 = '80',
  Level6 = '100',
  Level7 = '120',
  Level8 = '140',
  Level9 = '160',
  Level10 = '180',
  Level11 = '200',
  Level12 = '220',
}

export enum ViewerViewType {
  Scroll = 'Scroll',
  Page = 'Page',
}

export enum ViewerOptionKey {
  Theme = 'ViewerTheme',
  Font = 'ViewerFont',
  FontSize = 'ViewerFontSize',
  LineHeight = 'ViewerLineHeight',
  ParagraphIndent = 'ViewerParagraphIndent',
  Padding = 'ViewerPadding',
  Indentation = 'ViewerIndentation',
  ViewType = 'ViewerViewType',
  FancyShare = 'ViewerFancyShare',
}

export interface ViewerStyle {
  [ViewerOptionKey.Theme]: ViewerTheme;
  [ViewerOptionKey.Font]: ViewerFont;
  [ViewerOptionKey.FontSize]: ViewerFontSize;
  [ViewerOptionKey.LineHeight]: ViewerLineHeight;
  [ViewerOptionKey.ParagraphIndent]: ViewerParagraphIndent;
  [ViewerOptionKey.Padding]: ViewerPadding;
  [ViewerOptionKey.Indentation]: boolean;
  [ViewerOptionKey.ViewType]: ViewerViewType;
  [ViewerOptionKey.FancyShare]: boolean;
}
